import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

import { typeContainerService } from "../../../../../services/guide/typeContainer-service";
import { useFetchGetTypeContainerById } from "../../../../../hooks/guide/useFetchGetTypeContainerById";
import { CreateTypeContainer, UpdateTypeContainer } from "../../../../../types/api/guide/typeСontainer.types";

type FormState = { name: string; volume: string };

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = { name: "", volume: "" };

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };
        case "SET_All":
            return { ...action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

interface ContainerTypesAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id?: string;
}

export const ContainerTypesAddModal = ({ onClose, refetchData, id }: ContainerTypesAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const { data: typeContainer } = useFetchGetTypeContainerById(id);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!typeContainer) return;
        dispatch({
            type: "SET_All",
            payload: {
                name: typeContainer.name ?? "",
                volume: typeContainer.volume != null ? String(typeContainer.volume) : "",
            },
        });
    }, [typeContainer]);

    const handleValue = (event: any) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name, value });
    };

    const canSave = useMemo(() => {
        if (!state.name.trim()) return false;
        const v = Number(state.volume);
        return state.volume.trim() !== "" && Number.isFinite(v) && v >= 0;
    }, [state.name, state.volume]);

    const handleSave = async () => {
        try {
            const volume = Number(state.volume);
            if (!typeContainer) {
                const payload: CreateTypeContainer = { name: state.name.trim(), volume };
                await typeContainerService.create(payload);
                showSuccess("Тип контейнера создан");
            } else {
                const payload: UpdateTypeContainer = { id: typeContainer.id, name: state.name.trim(), volume };
                await typeContainerService.update(typeContainer.id, payload);
                showSuccess("Тип контейнера обновлён");
            }

            refetchData();
            // onClose();
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении типа контейнера");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {typeContainer ? "Редактировать тип контейнера" : "Добавить тип контейнера"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField name="name" value={state.name} onChange={handleValue} fullWidth />
                        </div>
                    </div>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Объём</div>
                        <div className={styles.modalCoords}>
                            <TextField
                                name="volume"
                                value={state.volume}
                                onChange={handleValue}
                                fullWidth
                                type="number"
                                inputProps={{ min: 0, step: "any" }}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>Отмена</button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave}
                        style={{ opacity: canSave ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};
